import Component from '../Component';
import PIXIViewport from 'pixi-viewport';
import Viewport from '../../Prototype/Viewport';

export default class ViewportComponent extends Component<
    PIXIViewport,
    Viewport
> {
    set pause(value: boolean) {
        this.container.pause = value;
    }

    get pause(): boolean {
        return this.container.pause;
    }

    set drag(value: {}) {
        this.container.drag(value);
    }

    set decelerate(value: { friction: number }) {
        this.container.decelerate(value);
    }

    set clamp(value: { direction: 'all' }) {
        this.container.clamp(value);
    }
}
